module.exports = __webpack_public_path__ + "0170661531d65d512e43993fcda1e78d.png";